import React from "react";
import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Login from "./routes/login";
import Register from "./routes/register";
import Home from "./routes/home";
import Profile from "./routes/profile";
import Edit from "./routes/edit";
import Members from "./routes/members";
import ReportWebVitals from "./reportWebVitals";
import Terms from "./routes/terms";
import Privacy from "./routes/privacy";
import PublicProfile from "./routes/PublicProfile";
import { endSession } from "./session";
import Loading from "./components/Loading";
import ProtectedRoute from "./components/ProtectedRoute";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#0d1117",
      paper: "#161b22",
    },
    primary: {
      main: "#00d4ff",
    },
    text: {
      primary: "#e6edf3",
      secondary: "#8b949e",
    },
    divider: "#30363d",
  },
});



const App = () => {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [locationPermissionGranted, setLocationPermissionGranted] = 
    React.useState(false);

  React.useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    try {
      await endSession();
      setUser(null);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const requestLocationPermission = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocationPermissionGranted(true);
        },
        (error) => {
          console.error("Error getting location:", error);
          setLocationPermissionGranted(false);
        }
      );
    } else {
      setLocationPermissionGranted(false);
    }
  };

  React.useEffect(() => {
    requestLocationPermission();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <ThemeProvider theme={darkTheme}>
    <CssBaseline />
    <Router>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={user ? <Navigate to="/home" /> : <Login />} />
        <Route path="/register" element={user ? <Navigate to="/home" /> : <Register />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/perfil/:uid" element={<PublicProfile />} />

        {/* Rutas protegidas */}
        <Route
          path="/"
          element={
            <ProtectedRoute user={user}>
              <Home
                handleLogout={handleLogout}
                locationPermissionGranted={locationPermissionGranted}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/home"
          element={
            <ProtectedRoute user={user}>
              <Home
                handleLogout={handleLogout}
                locationPermissionGranted={locationPermissionGranted}
              />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute user={user}>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit"
          element={
            <ProtectedRoute user={user}>
              <Edit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <ProtectedRoute user={user}>
              <Members />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reportWebVitals"
          element={
            <ProtectedRoute user={user}>
              <ReportWebVitals />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
    </ThemeProvider>
  );
};

export default App;